import React from 'react';
import { CheckCircleIcon, LockIcon, CreditCardIcon } from 'lucide-react';
import { trackAddToCart } from '../../utils/metaPixel';
export function PriceSection() {
  return <section id="pricing" className="py-12 md:py-20 bg-navy-dark relative overflow-hidden" data-id="element-90">
      {/* Glow Effect */}
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full h-full max-w-4xl bg-gold/5 blur-3xl rounded-full pointer-events-none" data-id="element-91"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-92">
        <div className="bg-white rounded-3xl overflow-hidden shadow-2xl" data-id="element-93">
          <div className="bg-gold p-3 text-center" data-id="element-94">
            <p className="text-navy-dark font-bold text-xs tracking-widest uppercase" data-id="element-95">
              ⏰ Oferta Especial por Tiempo Limitado
            </p>
          </div>

          <div className="p-6 md:p-12 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12" data-id="element-96">
            <div data-id="element-97">
              <h3 className="font-heading text-2xl md:text-3xl font-bold text-navy mb-1" data-id="element-98">
                El Código del Crédito 750+
              </h3>
              <p className="text-gray-500 text-sm mb-4" data-id="element-99">
                Acceso inmediato digital
              </p>

              <div className="space-y-3 mb-6" data-id="element-100">
                {[{
                label: 'Guía Maestra de Crédito',
                value: '$67'
              }, {
                label: 'Pack de Cartas Legales',
                value: '$49'
              }, {
                label: 'Estrategia de Reconstrucción',
                value: '$42'
              }, {
                label: 'Bonus: Deducibles',
                value: '$30'
              }].map((row, i) => <div key={i} className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-101">
                    <span className="text-gray-600 text-sm" data-id="element-102">{row.label}</span>
                    <span className="font-bold text-navy text-sm" data-id="element-103">
                      {row.value}
                    </span>
                  </div>)}
                <div className="flex justify-between items-center pt-1" data-id="element-104">
                  <span className="font-bold text-gray-800" data-id="element-105">Valor Total</span>
                  <span className="font-bold text-red-500 line-through decoration-2" data-id="element-106">
                    $188
                  </span>
                </div>
              </div>
            </div>

            <div className="flex flex-col justify-center items-center bg-cream/50 p-5 rounded-xl border border-gold/20" data-id="element-107">
              <div className="text-center mb-4" data-id="element-108">
                <p className="text-gray-500 text-sm mb-1" data-id="element-109">Tu inversión hoy</p>
                <div className="flex items-start justify-center text-navy" data-id="element-110">
                  <span className="text-xl font-bold mt-1" data-id="element-111">$</span>
                  <span className="text-5xl font-heading font-bold" data-id="element-112">9.36</span>
                  <span className="text-base font-bold mt-6" data-id="element-113">USD</span>
                </div>
              </div>

              <a href="https://mjebook.com/cart/43089190092918:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="w-full bg-red-accent hover:bg-red-700 text-white font-bold text-lg py-4 px-6 rounded-lg shadow-lg transform transition hover:scale-105 mb-3 flex items-center justify-center gap-2" data-id="element-114">
                DESCARGAR AHORA
                <CreditCardIcon className="w-5 h-5" data-id="element-115" />
              </a>

              <div className="flex items-center justify-center gap-2 text-xs text-gray-500 mb-3" data-id="element-116">
                <LockIcon className="w-3 h-3" data-id="element-117" />
                <span data-id="element-118">Pago 100% Seguro y Encriptado</span>
              </div>

              <div className="text-center" data-id="element-119">
                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Stripe_Logo%2C_revised_2016.svg/2560px-Stripe_Logo%2C_revised_2016.svg.png" alt="Powered by Stripe" className="h-5 mx-auto opacity-50" data-id="element-120" />
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mt-8 md:mt-12" data-id="element-121">
          <h3 className="text-white font-heading text-xl md:text-2xl mb-3" data-id="element-122">
            ¿Cuánto vale tu tranquilidad?
          </h3>
          <p className="text-gray-400 max-w-2xl mx-auto text-sm md:text-base" data-id="element-123">
            Tu inversión hoy es menos de lo que gastas en una cena, pero el
            retorno durará toda tu vida en este país.
          </p>
        </div>
      </div>
    </section>;
}